import { Box, Skeleton } from '@mui/material';
import Paper from '@src/components/paper/paper';
import React from 'react';
import styled from '@emotion/styled';

const StyledPaper = styled(Paper)`
    width: 100%;
`;

const BlogSkeletonCard = () => {
    return (
        <StyledPaper>
            <Box display='flex'>
                <Skeleton height={100} width={100} variant='rectangular' />
                <Box width='100%' marginLeft={4}>
                    <Skeleton height={12} width='40%' />
                    <Skeleton height={30} width='80%' />
                    <Skeleton height={50} width='90%' />
                </Box>
            </Box>
        </StyledPaper>
    );
};

export default BlogSkeletonCard;
